class CartIconBubble extends HTMLElement {
    constructor() {
        super();

        this.bindEvents = this.bindEvents.bind(this);
    }

    connectedCallback() {
        this.cartBubbleEl = this;
        this.bindEvents();
    }

    bindEvents() {
        const events = ["theme:cart:updated","theme:drawer:cart:update"];

        for(const event in events) {
            document.addEventListener(events[event], async () => {
                document.querySelector('#cart-icon-bubble').classList.add("cart-bubble-animate");

                if (this.cartBubbleEl.parentElement) {
                    this.cartBubbleEl.parentElement.innerHTML = await fetch(`${routes.cart_url}?view=count`).then(response => response.text()).then(html => html);
                }

                setTimeout(() => {
                    document.querySelector('#cart-icon-bubble').classList.remove("cart-bubble-animate");
                }, 400);
            })
        }
    }
}

customElements.define('w3-cart-bubble', CartIconBubble);
